<template>
  <div class="vx-row">
    <div class="w-full vx-col">
        <vx-card  titleIcon="FilterIcon" ref="filterCard" title="Advanced Filters" class="mb-8 user-list-filters" :collapse-action="true">
            <div class="vx-row">
                <div class="w-full vx-col md:w-1/3 sm:w-1/2">
                    <label class="text-sm opacity-100 text-bold">Name</label>
                    <vs-input type="search"  placeholder="Search.." v-model="filters['name']" class="w-full mb-4 md:mb-0"/>
                </div>
            </div>
            <div class="mt-5 vx-row">
                <div class="w-full ml-auto vx-col">
                    <vs-button class="float-right mr-4" size="small"
                                color="danger" type="border" icon-pack="feather" v-on:click="filters={}" >CLEAR</vs-button>
                </div>
            </div>
        </vx-card>
      <vx-card :title="'REGIONS'" class="">
        <template slot="actions">
          <vs-button @click.stop="onClickAdd" icon-pack="feather" icon="icon-plus" class="mr-4"  color="primary" type="filled">create</vs-button>
        </template>
        <div id="regions-table" class="vx-row">
          <div class="w-full vx-col">

            <vs-table stripe sort class="mt-8" :data="regions">
              <template slot="thead">
                <vs-th width="25%">Name</vs-th>
                <vs-th width="40%">Country Codes</vs-th>
                <vs-th width="10%">Action</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr class="cursor-pointer" :key="indextr" v-for="(tr, indextr) in data">

                  <vs-td :data="data[indextr].name">
                    {{ data[indextr].name }}
                  </vs-td>

                   <vs-td :data="data[indextr].country_codes">
                    <span v-for="(country, index_country) in data[indextr].country_codes" :key="index_country">
                      {{ country.name }} ,
                    </span>
                  </vs-td>

                  <vs-td :data="data[indextr].name">
                    <div class="justify-start vx-row">
                      <vx-tooltip text="View/Update" position="left">
                        <vs-button @click.stop="onClickUpdate(data[indextr].id)"  class="ml-3"
                                   size="small" color="warning" type="border" icon-pack="feather" icon="icon-edit-2"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip text="Remove" position="left">
                        <vs-button @click.stop="openConfirm(data[indextr])" class="ml-3"
                                   size="small" color="danger" type="border" icon-pack="feather" icon="icon-trash-2"></vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>

                </vs-tr>
              </template>

            </vs-table>
            <vs-pagination
              v-on:changeMaxItems="changePage"
              :size-array="meta.total ? meta.total : 20"
              :max-items="perPage"
              description-body="Rows per page"
              description-connector="of"
              description-title="Records"
              description
              :description-items="descriptionItems"
              :total="(meta.last_page)? meta.last_page : 0"
              v-model="page"  class="p-5">
            </vs-pagination>


          </div>
        </div>
      </vx-card>
    </div>
    <add-new-regions-pop-up ref="addNewRegionsPopUp"/>
  </div>
</template>

<script>
  import {RepositoryFactory} from '@/repository/RepositoryFactory';
  import AddNewRegionsPopUp from "@/components/popups/settings/regions/AddNewRegionsPopUp";
  import vSelect from 'vue-select'

  import Filter from '@/mixins/filter';
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  import {defaultPagination, perPageList} from "@/constants/config";

  const RegionsRepository = RepositoryFactory.get('regions');

  export default {
    name: "CcpItemSettings",
    data() {
      return {
        regions: [],
        filters: {},
        page : 1,
        total: 0,
        meta : {},
        sort : '',
        perPage: defaultPagination,
        descriptionItems: perPageList,
      }
    },
    components: {
      AddNewRegionsPopUp,
      'v-select': vSelect,
    },
    methods: {
      async refreshData() {
        await this.fetchRegions()
      },
      async fetchRegions() {
        await this.$vs.loading({
          container: '#regions-table',
          scale: 0.45
        })
        const {data} = await RegionsRepository.getListOfRegions(this.page, this.filterQuery, this.perPage, this.sort)
        this.regions =  data.data
        this.meta = data.meta
        this.$vs.loading.close('#regions-table > .con-vs-loading')
      },
      async onClickAdd() {
        await this.$refs.addNewRegionsPopUp.openPopup()
      },
      async onClickUpdate(id) {
        await this.$refs.addNewRegionsPopUp.openPopup(id)
      },
      openConfirm(data) {
        if(data.sage_nominal_code.length > 0){
          this.$vs.dialog({
            title: 'Error',
            text: `You cannot remove this region (${data.name}) that is used against a nominal code (${data.sage_nominal_code.map((x) => x.code).toString()}). Remove that first then delete the region.`,
            color: 'danger',
            acceptText: 'Close'
          })
        } else {
          this.$vs.dialog({
            type: 'confirm',
            color: 'danger',
            title: `Confirm`,
            text: 'Are you sure you want to delete this ?',
            accept: this.onClickDelete,
            parameters: [data.id]
          })
        }
      },
      async onClickDelete(params) {
        try {
          await RegionsRepository.deleteRegion(params[0])
          await this.fetchRegions()
          await this.showSuccessMessage('Region deleted successfully!');
        }catch (e) {
          this.convertAndNotifyError(e)
        }
      },
      filterQueryUpdate (){
        this.fetchRegions()
      },

      handleChangePage(page) {
        this.page=page;
        this.fetchRegions()
      },
      handleSort(key, active) {
        if(key){
          active = (active==='desc')? "-":'';
          this.sort=active+key;
          this.fetchRegions()
        }
      },
      changePage(index) {
        this.perPage = this.descriptionItems[index]
      },
    },
    async mounted() {
      await this.fetchRegions()
    },
    mixins: [Filter, SuccessMessage, ErrorMessages],
     watch : {
      page(){
        this.fetchRegions()
      },
      perPage() {
        this.fetchRegions()
      }
    }
  }
</script>

<style scoped>

</style>
